import { render, staticRenderFns } from "./piliang.vue?vue&type=template&id=52e50460"
import script from "./piliang.vue?vue&type=script&lang=js"
export * from "./piliang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports